import { motion } from 'framer-motion'
import { XMarkIcon } from '@heroicons/react/24/outline'

interface YouTubeVideoModalProps {
  videoId: string
  title?: string
  onClose: () => void
}

/** 북마크 목록에서 YouTube 링크를 바로 재생하는 모달 */
export default function YouTubeVideoModal({
  videoId,
  title,
  onClose,
}: YouTubeVideoModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="relative w-full max-w-4xl overflow-hidden rounded-lg bg-black"
      >
        {/* 모달 헤더 */}
        <div className="absolute left-0 right-0 top-0 z-10 flex items-center justify-between bg-gradient-to-b from-black/80 to-transparent p-4">
          <h3 className="truncate pr-4 font-semibold text-white">
            {title || 'YouTube Video'}
          </h3>
          <button
            onClick={onClose}
            className="rounded-full p-2 text-white transition-colors hover:bg-white/20 hover:text-gray-300"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* YouTube 임베드 */}
        <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
          <iframe
            className="absolute inset-0 h-full w-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
            title={title || 'YouTube Video'}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </motion.div>
    </div>
  )
}

// Types - 이제 공통 타입을 사용
